export default __webpack_public_path__ + "static/media/fjarrtolkning1.de4689d1.png";